import type { PlaidEnvironment } from './_types';

const getPlaidTokenKey = (tenantId: string) => `${tenantId}_plaid_token`;
const getPlaidTokenUserKey = (tenantId: string) =>
  `${tenantId}_plaid_token_user`;

export function savePlaidTokenToLocalStorage(
  tenantId: string,
  token: string,
  environment: PlaidEnvironment,
  userId?: string | null
) {
  localStorage.setItem(getPlaidTokenKey(tenantId), `${environment}_${token}`);

  if (userId) {
    localStorage.setItem(getPlaidTokenUserKey(tenantId), userId);
    return;
  }

  localStorage.removeItem(getPlaidTokenUserKey(tenantId));
}

export function getPlaidTokenFromLocalStorage(
  tenantId: string,
  userId?: string | null
) {
  const stored = localStorage.getItem(getPlaidTokenKey(tenantId));

  if (!stored) {
    return null;
  }

  const separatorIndex = stored.indexOf('_');

  if (separatorIndex <= 0) {
    return null;
  }

  const storedUserId = localStorage.getItem(getPlaidTokenUserKey(tenantId));

  if (storedUserId && userId && storedUserId !== userId) {
    return null;
  }

  const environment = stored.slice(0, separatorIndex) as PlaidEnvironment;
  const token = stored.slice(separatorIndex + 1);

  return {
    environment,
    token,
  };
}

export function clearPlaidTokenFromLocalStorage(tenantId: string) {
  localStorage.removeItem(getPlaidTokenKey(tenantId));
  localStorage.removeItem(getPlaidTokenUserKey(tenantId));
}
